/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum NoteLevel {
  Info = "info",
  Warning = "warning",
  Error = "error",
}

export function instanceOfNoteLevel(value: any): boolean {
  for (const key in NoteLevel) {
    if (Object.prototype.hasOwnProperty.call(NoteLevel, key)) {
      if (NoteLevel[key as keyof typeof NoteLevel] === value) {
        return true;
      }
    }
  }
  return false;
}

export function NoteLevelFromJSON(json: any): NoteLevel {
  return NoteLevelFromJSONTyped(json, false);
}

export function NoteLevelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): NoteLevel {
  return json as NoteLevel;
}

export function NoteLevelToJSON(value?: NoteLevel | null): any {
  return value as any;
}

export function NoteLevelToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): NoteLevel {
  return value as NoteLevel;
}
